import React, { ReactElement } from 'react';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { ComponentType, Props } from './BulkPrice.types';
import './BulkPrice.scss';

const BulkPrice: ComponentType = ({
  discount,
  fromQuantity,
}: Props): ReactElement => {
  const t = useTranslate();
  const text = {
    line: t(
      'From {fromQuantity} pieces, <strong>CHF {discount}</strong> discount',
      {
        fromQuantity,
        discount: discount.toFixed(2),
      },
    ),
  };

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: text.line,
      }}
      className="BulkPrices-BulkPrice"
    />
  );
};

export { BulkPrice };
